// extracted by mini-css-extract-plugin
module.exports = {"bg":"circle-hero_bg__c2VhG","title":"circle-hero_title__mVsBq","description":"circle-hero_description__af2Ex"};